<template>
  <div class="wrapper">
    <!-- Header Start -->
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center">
            <h1 class="title">Epoxy</h1>
            <h4>
              Free global delivery for all products. Use coupon
              <b>25summer</b> for an extra 25% Off
            </h4>
          </div>
        </div>
      </div>
    </parallax>
    <!-- Header end -->
    <div class="main">
      <div class="section">
        <div class="container">
          <div class="section pb-0">
            <div class="container">
              <h2 class="section-title">Find what you need</h2>
              <div class="md-layout md-alignment-center-center">
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <md-card class="md-card md-card-refine md-card-plain">
                    <md-card-content>
                      <div class="md-layout-item md-size-100 md-medium-size-100">
                        <div class="title">
                         
                        </div>
                        <tabs
                          :tab-active="1"
                          :tab-name="categories"
                          flex-row
                          plain
                          color-button="primary"
                          class="md-alignment-center-center"
                        >
                          <div v-for="(category, index) in categories" :key="index">
                            <template slot="tab-pane-1">
                              Hello there
                            </template>
                          </div>
                          <!-- here you can add your content for tab-content -->
                        </tabs>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <product-card
                        text-center
                        class="mt-3"
                        card-plain
                        :card-image="productCard.productCard4"
                        :shadow-off="true"
                      >
                        <template slot="cardContent">
                          <h4 class="card-title">Polo Ralph Lauren</h4>
                          <p
                            class="card-description"
                          >Impeccably tailored in Italy from lightweight navy wool.</p>
                        </template>
                        <template slot="cardAction">
                          <div class="price-container">
                            <span class="price">€800</span>
                          </div>
                          <div class="stats ml-auto">
                            <md-button class="md-just-icon md-rose md-round md-simple">
                              <md-icon>favorite</md-icon>
                              <md-tooltip md-direction="left">Remove from Wishlist</md-tooltip>
                            </md-button>
                          </div>
                        </template>
                      </product-card>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <product-card
                        text-center
                        class="mt-3"
                        card-plain
                        :card-image="productCard.productCard5"
                        :shadow-off="true"
                      >
                        <template slot="cardContent">
                          <h4 class="card-title">Wooyoungmi</h4>
                          <p class="card-description">Dark-grey slub wool, pintucked notch lapels.</p>
                        </template>
                        <template slot="cardAction">
                          <div class="price-container">
                            <span class="price">€555</span>
                          </div>
                          <div class="stats ml-auto">
                            <md-button class="md-just-icon md-rose md-round md-simple">
                              <md-icon>favorite_border</md-icon>
                              <md-tooltip md-direction="left">Save to Wishlist</md-tooltip>
                            </md-button>
                          </div>
                        </template>
                      </product-card>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <product-card
                        text-center
                        class="mt-3"
                        card-plain
                        :card-image="productCard.productCard6"
                        :shadow-off="true"
                      >
                        <template slot="cardContent">
                          <h4 class="card-title">Tom Ford</h4>
                          <p class="card-description">Immaculate tailoring is TOM FORD's forte.</p>
                        </template>
                        <template slot="cardAction">
                          <div class="price-container">
                            <span class="price">€879</span>
                          </div>
                          <div class="stats ml-auto">
                            <md-button class="md-just-icon md-rose md-round md-simple">
                              <md-icon>favorite_border</md-icon>
                              <md-tooltip md-direction="left">Save to Wishlist</md-tooltip>
                            </md-button>
                          </div>
                        </template>
                      </product-card>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <product-card
                        text-center
                        class="mt-3"
                        card-plain
                        :card-image="productCard.productCard7"
                        :shadow-off="true"
                      >
                        <template slot="cardContent">
                          <h4 class="card-title">Thom Sweeney</h4>
                          <p class="card-description">It's made from lightweight grey wool woven.</p>
                        </template>
                        <template slot="cardAction">
                          <div class="price-container">
                            <span class="price">€680</span>
                          </div>
                          <div class="stats ml-auto">
                            <md-button class="md-just-icon md-rose md-round md-simple">
                              <md-icon>favorite_border</md-icon>
                              <md-tooltip md-direction="left">Save to Wishlist</md-tooltip>
                            </md-button>
                          </div>
                        </template>
                      </product-card>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <product-card
                        text-center
                        class="mt-3"
                        card-plain
                        :card-image="productCard.productCard8"
                        :shadow-off="true"
                      >
                        <template slot="cardContent">
                          <h4 class="card-title">Kingsman</h4>
                          <p class="card-description">Crafted from khaki cotton and fully canvassed.</p>
                        </template>
                        <template slot="cardAction">
                          <div class="price-container">
                            <span class="price">€725</span>
                          </div>
                          <div class="stats ml-auto">
                            <md-button class="md-just-icon md-rose md-round md-simple">
                              <md-icon>favorite</md-icon>
                              <md-tooltip md-direction="left">Remove from Wishlist</md-tooltip>
                            </md-button>
                          </div>
                        </template>
                      </product-card>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <product-card
                        text-center
                        class="mt-3"
                        card-plain
                        :card-image="productCard.productCard9"
                        :shadow-off="true"
                      >
                        <template slot="cardContent">
                          <h4 class="card-title">Boglioli</h4>
                          <p class="card-description">Masterfully crafted in Northern Italy.</p>
                        </template>
                        <template slot="cardAction">
                          <div class="price-container">
                            <span class="price">€699</span>
                          </div>
                          <div class="stats ml-auto">
                            <md-button class="md-just-icon md-rose md-round md-simple">
                              <md-icon>favorite_border</md-icon>
                              <md-tooltip md-direction="left">Save to Wishlist</md-tooltip>
                            </md-button>
                          </div>
                        </template>
                      </product-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ProductCard,
  Collapse,
  FullBgCard,
  BlogCard,
  Slider,
  Tabs
} from "@/components";

import Mixins from "@/plugins/basicMixins";

export default {
  components: {
    ProductCard,
    Tabs
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  data() {
    return {
      subscribe: null,
      sliders: {
        rangeSlider: [101, 700]
      },
      clothing: {
        blazers: true,
        casualShirts: false,
        formalShirts: false,
        jeans: false,
        polos: false,
        pyjamas: false,
        shorts: false,
        trousers: false
      },
      designer: {
        all: true,
        polo: false,
        wooyoungmi: false,
        alexander: false,
        tom: false,
        ami: false,
        berena: false,
        sweeney: false,
        burberry: false,
        calvin: false,
        kingsman: false,
        monaco: false,
        dolce: false,
        gucci: false,
        biglioli: false,
        lanvin: false,
        piana: false,
        massimo: false
      },
      colour: {
        all: true,
        black: false,
        blue: false,
        brown: false,
        gray: false,
        green: false,
        neutrals: false,
        purple: false
      },
      image: require("@/assets/img/examples/clark-street-merc.jpg"),
      image2: require("@/assets/img/examples/ecommerce-header.jpg"),
      productCard: {
        productCard1: require("@/assets/img/examples/gucci.jpg"),
        productCard2: require("@/assets/img/examples/dolce.jpg"),
        productCard3: require("@/assets/img/examples/tom-ford.jpg"),
        productCard4: require("@/assets/img/examples/suit-1.jpg"),
        productCard5: require("@/assets/img/examples/suit-2.jpg"),
        productCard6: require("@/assets/img/examples/suit-3.jpg"),
        productCard7: require("@/assets/img/examples/suit-4.jpg"),
        productCard8: require("@/assets/img/examples/suit-5.jpg"),
        productCard9: require("@/assets/img/examples/suit-6.jpg")
      },
      cardBg: {
        cardBg1: require("@/assets/img/examples/color1.jpg"),
        cardBg2: require("@/assets/img/examples/color3.jpg"),
        cardBg3: require("@/assets/img/examples/color2.jpg"),
        cardBg4: require("@/assets/img/nature-2.jpg"),
        cardBg5: require("@/assets/img/nature-2.jpg")
      },
      cardBlog: {
        cardBlog1: require("@/assets/img/nature-2.jpg"),
        cardBlog2: require("@/assets/img/nature-2.jpg"),
        cardBlog3: require("@/assets/img/nature-2.jpg")
      },
      categories: ["Tables", "Chairs", "Suitcases"]
    };
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
